/**
 * ファームウェア用のスクリプト
 */
if (is_route('device_application.index')) {
    // コンテンツ読み込み後
    $(document).on('bss:onload', function() {
        device_application_event_set();
    });
}

/**
 * ページ読み込み時のイベント設定
 */
window.device_application_event_set = function() {

    /*---- 設定表示時 ----*/

    // 設定表示時
    $(document).on('click', '[data-setting-modal]', function () {
        _modal.create(this, 'setting-modal', ['id']);
    });

    /*---- 設定の保存時 ----*/

    // 設定保存時
    $(document).on('click', '[data-save-modal]', function () {
        _modal.submit(this, 'save-modal');
    });

    /*---- 詳細表示時 ----*/

    // 詳細表示時
    $(document).on('click', '[data-detail-modal]', function () {
        _modal.create(this, 'detail-modal', ['id'], false, function() {
            device_application_detail_event_set();
        });
    });

    /*---- 削除確認時 ----*/

    // 削除確認時
    $(document).on('click', '[data-confirm-modal]', function () {
        _modal.create(this, 'confirm-modal', ['id'], true);
    });

    /*---- 削除時 ----*/

    // 削除実行時
    $(document).on('click', '[data-delete-modal]', function () {
        _modal.submit(this, 'delete-modal');
    });

    /*---- リリース設定表示時 ----*/

    // 設定表示時
    $(document).on('click', '[data-release-modal]', function () {
        _modal.create(this, 'release-modal', ['id'], false, function() {
            device_application_release_event_set();
        });
    });

    /*---- リリース設定の保存時 ----*/

    // 設定保存時
    $(document).on('click', '[data-release-save-modal]', function () {
        _modal.submit(this, 'release-save-modal');
    });

    /*---- リリース中止確認時 ----*/

    // 削除確認時
    $(document).on('click', '[data-release_confirm-modal]', function () {
        _modal.create(this, 'release_confirm-modal', ['id'], true);
    });

    /*---- リリース中止時 ----*/

    // 削除実行時
    $(document).on('click', '[data-release_delete-modal]', function () {
        _modal.submit(this, 'release_delete-modal');
    });
}

/**
 * リリース設定時のイベント設定
 */
window.device_application_release_event_set = function()
{
    // -----------------------------
    // 車両情報一覧取得
    // -----------------------------
    let release_modal = $('#device_application-release-modal');
    let list_area = release_modal.find('.list-area');
    // 検索フォームの変更時
    $('#search_vehicle select').on('change', function() {
        // tbodyを空に
        list_area.find('tbody').empty();

        let holding = $('#search_vehicle select.holding-select');
        let company = $('#search_vehicle select.company-select');
        let section = $('#search_vehicle select.section-select');
        // holdingのchange時は、通信しない(companyクリアされるため)
        if ($(this).hasClass('holding-select')) return;
        // holding、company選択無ければ、通信しない
        if (!holding.val() || !company.val()) return;
        // select,jsの処理待たず、子の値をクリア
        if ($(this).hasClass('company-select')) section.val('');

        // 送信
        let action = $('#search_vehicle').data('action');
        let params = {
            'holding_id': holding.val(),
            'company_id': company.val(),
            'section_id': section.val(),
            'device_application_id': $('input[name="device_application_id"]').val(),
        }
        _ajax.post(action, params, function (results) {
            list_area.find('tbody').html(results);
        }, function(xhr, status, errorThrown) {
            _error.omitted(xhr, status, errorThrown);
        }, 'html');
    });

    // -----------------------------
    // 車両選択チェックボックス制御
    // -----------------------------
    $(document).on('click', '#releases input[name="check_all"]', function() {
        let rowCheck = $('#releases input[name="vehicle_id[]"]');
        if ($(this).prop('checked')) {
            rowCheck.prop('checked', true);
        } else {
            rowCheck.prop('checked', false);
        }
    });
}

/**
 * 詳細画面リリース要素関連イベント設定
 */
window.device_application_detail_event_set = function()
{
    // -----------------------------
    // リリース一覧情報filter処理
    // -----------------------------
    function filter()
    {
        let rows = $('table#releases tbody tr');
        let holding = $('#release_filter select.holding-select');
        let company = $('#release_filter select.company-select');
        let section = $('#release_filter select.section-select');
        let status = $('#release_filter select#filter-status');
        let display;
        // filter
        rows.each(function() {
            display = true;

            if (holding.val() && $(this).data('holding_id').toString() !== holding.val().toString()) {
                display = false;
            }
            if (company.val() && $(this).data('company_id').toString() !== company.val().toString()) {
                display = false;
            }
            if (section.val() && $(this).data('section_id').toString() !== section.val().toString()) {
                display = false;
            }
            if (status.val() && $(this).data('status').toString() !== status.val().toString()) {
                display = false;
            }
            if (display) {
                $(this).removeClass('d-none');
            } else {
                $(this).addClass('d-none');
            }
        });
    }

    // filter処理イベント登録
    $('#release_filter select').on('change', function () {
        filter();
    });
}
